var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container",staticStyle:{"position":"relative","height":"30%","width":"98%"}},[_c('canvas',{ref:"chartEl",attrs:{"width":"98%","height":"30%"}},[_c('p',[_vm._v("Disk SD storage")])])])}
var staticRenderFns = []

export { render, staticRenderFns }